const initialState = {
    id: '',
    name: '',
    role: '',
    convoDate: new Date().toDateString(),
    convoCode: '',
    finished: false,
    authorizing: false,
    authorized: false
};

const user = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_USER_NAME':
            return Object.assign({}, state, {
                name: action.name
            });
        case 'SET_USER_ROLE':
            return Object.assign({}, state, {
                role: action.role
            });
        case 'SET_USER_CONVO':
            return Object.assign({}, state, {
                convoCode: action.convoCode
            });
        case 'USER_START_AUTHORIZING':
            return Object.assign({}, state, {
                authorizing: true
            });
        case 'USER_AUTHORIZED':
            return Object.assign({}, state, {
                authorizing: false,
                authorized: true
            });
        case 'USER_NO_EXIST':
            return Object.assign({}, state, {
                authorizing: false,
                authorized: false
            });

        default:
            return state
    }
}

export default user;


// WEBPACK FOOTER //
// ./src/reducers/user.js